/**
 * API接口信息
 */

import GLOBAL from '@/lib/config';

// 主域名
let HOST = GLOBAL.WEB_SITE;

// #ifdef H5
HOST = '';
// #endif

// HOST_H5
export const HOST_H5 = HOST + '/h5/';
// HOST_API
export const HOST_API = HOST + '/api/';
// HOST_INDEX
export const HOST_INDEX = HOST + '/index/';
// QI_NIU_HOST
export const QI_NIU_HOST = 'https://qiniu.315sd.com/';
// QI_NIU_UPLOAD_HOST
export const QI_NIU_UPLOAD_HOST = 'https://up-z0.qiniup.com';
// ad_position
export const ad_position = HOST_INDEX + 'index/ad_position';
// send_msg_code
export const send_msg_code = HOST_API + 'register/send_msg_code';
// member_info
export const member_info = HOST_API + 'general/member_info';
// loginin
export const loginin = HOST_INDEX + 'login/loginin';
// register
export const register = HOST_API + 'register/register';
// new_hot
export const new_hot = HOST_API + 'general/new_hot';
// article_detail
export const article_detail = HOST_API + 'general/article_detail';
// a_comment_list
export const a_comment_list = HOST_INDEX + 'comment/a_comment_list';
// apost_comment
export const apost_comment = HOST_INDEX + 'comment/apost_comment';
// message_list
export const message_list = HOST_API + 'general/message_list';
// complaint_list
export const complaint_list = HOST_API + 'general/complaint_list';
// detail
export const detail = HOST_API + 'general/detail';
// comment_list
export const comment_list = HOST_INDEX + 'comment/comment_list';
// complaint_list_ad
export const complaint_list_ad = HOST_INDEX + 'index/complaint_list_ad';
// get_cate
export const get_cate = HOST_INDEX + 'complaint/get_cate';
// post_data
export const post_data = HOST_INDEX + 'complaint/post_data';
// leader_board
export const leader_board = HOST_API + 'general/leader_board';
// lb_article
export const lb_article = HOST_API + 'general/lb_article';
// cate_article
export const cate_article = HOST_API + 'general/cate_article';
// market_article
export const market_article = HOST_API + 'general/market_article';
// talent_article
export const talent_article = HOST_INDEX + 'index/talent_article';
// train_article
export const train_article = HOST_INDEX + 'index/train_article';
// article_list_ad
export const article_list_ad = HOST_INDEX + 'index/article_list_ad';
// set_headimg
export const set_headimg = HOST_API + 'general/set_headimg';
// set_myinfo
export const set_myinfo = HOST_API + 'general/set_myinfo';
// find_pass
export const find_pass = HOST_INDEX + 'login/find_pass';
// edit_pass
export const edit_pass = HOST_INDEX + 'login/edit_pass';
// view_sd
export const view_sd = HOST_API + 'general/view_sd';
// article_list
export const article_list = HOST_INDEX + 'index/article_list';